export const DEPENDENCY_DRAG_ITEM_ID = 'dependency-drag-id';
export const DEPENDENCIES_DROP_TARGET_CLASS_NAME = 'dependencies-drop-target';

export const INCOMING = 'INCOMING' as const;
export const OUTGOING = 'OUTGOING' as const;
